type Props = {
	headerChildren: React.ReactNode;
	contentChildren: React.ReactNode;
};

export const Calendar = ({ headerChildren, contentChildren }: Props) => {
	return (
		<div className="space-y-4">
			<div className="text-center">
				<h4 className="text-xl font-bold">宿泊カレンダー</h4>
			</div>

			<div className="rounded border">
				{headerChildren}

				<div className="p-4">{contentChildren}</div>
			</div>

			<div className="text-right text-sm text-zinc-800">
				<p>※件数をクリックとカレンダー下部に詳細情報が表示されます</p>
				<p>※日帰りはチェックイン日を起点にしています</p>
			</div>
		</div>
	);
};
